
<div *ngIf="harTilgang">

  <h1>{{overskrift}}</h1>

  <app-soketekstfilter (onFilterChange)="onFilterChange($event)" [filterParams]="filterParams"></app-soketekstfilter>
  <app-serverfilter (onFilterChange)="onFilterChange($event)" [filterParams]="filterParams"></app-serverfilter>
  <app-paginator (onFilterChange)="onFilterChange($event)" [filterParams]="filterParams"></app-paginator>

  <app-spinner [loadingData]="loadingData"></app-spinner>


  <div *ngIf="searchResults">
    <p class="text-center">Antall treff ({{filterParams.numberOfHits}})</p>
    <div class="search-results">
      <div *ngFor="let searchItem of searchResults" class="list-group-flush">
        <a [routerLink]="[searchItem.serverId]"
           class="list-group-item list-group-item-action flex-column align-items-end">
          <h5>{{searchItem.navn}}</h5>
          <div class="text-muted">{{searchItem.beskrivelse}}</div>
          <div class="text-muted">Antall tilkoblede systemer: {{searchItem.systemCount}}</div>
        </a>
      </div>
    </div>

  </div>



</div>

<app-ikketilgang [harTilgang]="harTilgang" [loadingData]="loadingData" [overskrift]="overskrift"></app-ikketilgang>
